import { LoadingButton } from "@mui/lab";
import { Button, CircularProgress, Stack, TextField } from "@mui/material";
import React, { useState } from "react";
import useAxiosInstance from "../../../../../hooks/useAxiosInstance";
import { API_RESULT, API_VERSION } from "../../../../../enums/common.enum";
import { errorToast, handleError } from "../../../../../utils/common";

const BorrowerBusinessPanValidate = ({
  business_pan_no,
  handleBlur,
  errors,
  touched,
  setFieldValue,
}: any) => {
  return (
    <Stack direction={{ xs: "column", md: "row" }}>
      <TextField
        fullWidth
        id="business_pan_no"
        label="PAN Number"
        size="small"
        value={business_pan_no || ""}
        sx={{ mt: 1.5, mr: { xs: 0, md: 1 } }}
        onBlur={handleBlur}
        onChange={(e) =>
          setFieldValue("business_pan_no", e.target.value.toUpperCase())
        }
        InputLabelProps={{
          required: true,
        }}
        helperText={
          errors.business_pan_no && touched.business_pan_no
            ? errors.business_pan_no
            : ""
        }
        error={errors.business_pan_no && touched.business_pan_no ? true : false}
      />
    </Stack>
  );
};

export default BorrowerBusinessPanValidate;
